import { IProcessable } from "./processable.interface";

export interface IChainable<NextInputType> {

	connectTo(next: IProcessable<NextInputType>);
}
